import request from './request'

const authApi = {
  login (data) {
    return request.post('/login', data)
  },
  checkToken (token) {
    return request.get('/checkToken/' + token)
  },
}

export default authApi
